import type {
  Data, Variables, Cache, UpdatesConfig,
} from '@urql/exchange-graphcache';

import invalidateQuery from '../util/invalidateQuery';

const formQueries = [
  'waiverForms',
  'waiverForm',
];

/** Form mutations that change unpublished / expiring counts on the dashboard. */
const formDashboardQueries = [
  ...formQueries,
  'waiverDashboardSummary',
  'waiverDashboardSubmissionVolume',
  'waiverDashboardFormSubmissions',
  'waiverDashboardFormsByCategory',
];

/** Queries that change when a form is published or otherwise status-updated. */
const formPublishedQueries = [
  ...formDashboardQueries,
  'waiverFormSubmissions',
];

const waiverFormMutations: UpdatesConfig['Mutation'] = {
  waiverFormCreate: (_: Data, __: Variables, cache: Cache) => {
    invalidateQuery(formDashboardQueries, cache);
  },
  waiverFormUpdate: (_: Data, __: Variables, cache: Cache) => {
    invalidateQuery(formDashboardQueries, cache);
  },
  waiverFormStatusUpdate: (_: Data, __: Variables, cache: Cache) => {
    invalidateQuery(formPublishedQueries, cache);
  },
  waiverFormDiscard: (_: Data, __: Variables, cache: Cache) => {
    invalidateQuery(formDashboardQueries, cache);
  },
  waiverFormRuleUpdate: (_: Data, __: Variables, cache: Cache) => {
    invalidateQuery(formQueries, cache);
  },
};

export default waiverFormMutations;
